import styled from "styled-components";

export const CalendarWrapper = styled.div`
  .ant-picker-calendar-mode-switch {
    display: none;
  }

  .ant-picker-cell-selected .ant-picker-cell-inner {
    background-color: transparent !important;

    &:hover {
      background-color: #0000000a !important;
    }
  }
`;
